import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: 'GamePage' */ '../pages/GamePage')
  },
  {
    path: '/pokedex',
    component: () =>
      import(/* webpackChunkName: 'PokedexPage' */ '../pages/PokedexPage')
  },
  {
    path: '/pokedex/:id',
    name: 'pokemon-id',
    component: () =>
      import(/* webpackChunkName: 'PokemonPage' */ '../pages/PokemonPage'),
    props: (route) => {
      const { id } = route.params
      return { id: Number(id) }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    component: () =>
      import(/* webpackChunkName: 'ErrorPage' */ '../pages/ErrorPage')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
